export var Field;

(function (Field) {
  Field["Text"] = "Text";
  Field["List"] = "List";
  Field["Date"] = "Date";
})(Field || (Field = {}));